import React from "react"
import { Link } from "gatsby"
import {
  SemiBdTitle3,
  SemiBdTitle4,
  IconChevronRight,
  RegBody,
} from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

const quoteIcon =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1715016107/pages/product/quote-icon_fcgo2o_ptzj7e.svg"

export interface ProductEntryTestimonialProps {
  testimonial: {
    company: string
    name: string
    position: string
    on: boolean
    quote: string
    readMore: {
      path: {
        current: string
      }
    }
  }
}

const ProductEntryTestimonial = ({
  testimonial,
}: ProductEntryTestimonialProps) => {
  if (!testimonial?.on) return null

  return (
    <ProductEntryTestimonialStyled>
      <div className="product-entry-testimonial__container">
        <img className="product-entry-testimonial__bg-image" src={quoteIcon} />
        <SemiBdTitle3 className="product-entry-testimonial__quote">
          {testimonial.quote}
        </SemiBdTitle3>
        <div className="product-entry-testimonial__name-position-container">
          {testimonial?.name ? (
            <RegBody className="product-entry-testimonial__name">
              {testimonial.name},
            </RegBody>
          ) : null}
          <RegBody className="product-entry-testimonial__position">
            {testimonial.position}
          </RegBody>
        </div>
        <RegBody className="product-entry-testimonial__company">
          {testimonial.company}
        </RegBody>
        <div className="product-entry-testimonial__link-container">
          <Link
            to={testimonial?.readMore?.path?.current || "/case-studies/"}
            className="product-entry-testimonial__link"
          >
            <div className="product-entry-testimonial__link-icon-container">
              <IconChevronRight color="var(--color-white)" />
            </div>
            <SemiBdTitle4 className="product-entry-testimonial__link-text">
              Read success stories
            </SemiBdTitle4>
          </Link>
        </div>
      </div>
    </ProductEntryTestimonialStyled>
  )
}

export default ProductEntryTestimonial

const ProductEntryTestimonialStyled = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: var(--color-gray900);
  color: var(--color-white);
  text-align: center;

  @media ${media.stMidUp} {
    max-width: ${rem(1312)};
    border-radius: ${rem(8)};
  }

  .product-entry-testimonial__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: ${rem(128)} ${rem(26)} ${rem(64)};

    @media ${media.midUp} {
      padding: ${rem(96)} ${rem(150)} ${rem(64)};
    }
  }

  .product-entry-testimonial__bg-image {
    position: absolute;
    width: ${rem(49)};
    height: ${rem(40)};
    top: ${rem(64)};

    @media ${media.midUp} {
      width: ${rem(68)};
      height: ${rem(56)};
      top: ${rem(56)};
      left: ${rem(64)};
    }
  }

  .product-entry-testimonial__quote {
    max-width: ${rem(321)};
    font-size: ${rem(16)};
    line-height: ${rem(24)};

    @media ${media.midUp} {
      max-width: ${rem(443)};
      font-size: ${rem(24)};
      line-height: ${rem(32)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(709)};
    }
  }

  .product-entry-testimonial__name-position-container {
    padding-top: ${rem(24)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .product-entry-testimonial__name {
      font-size: ${rem(16)};
      color: var(--color-primary-on-dark);

      @media ${media.midUp} {
        font-size: ${rem(20)};
        line-height: ${rem(32)};
      }
    }

    .product-entry-testimonial__position {
      font-size: ${rem(16)};
      color: var(--color-primary-on-dark);

      @media ${media.midUp} {
        font-size: ${rem(20)};
        line-height: ${rem(32)};
      }
    }
  }
  .product-entry-testimonial__company {
    color: var(--color-primary-on-dark);
    font-size: ${rem(16)};

    @media ${media.midUp} {
      font-size: ${rem(20)};
      line-height: ${rem(32)};
    }
  }

  .product-entry-testimonial__link-container {
    display: flex;
    justify-content: center;
    padding-top: ${rem(40)};

    @media ${media.midUp} {
      padding-top: ${rem(48)};
    }

    @media ${media.stMidUp} {
      padding-top: ${rem(40)};
    }

    .product-entry-testimonial__link {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: ${rem(8)};
      color: var(--color-white);
      text-decoration: none;
    }

    .product-entry-testimonial__link-icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${rem(32)};
      height: ${rem(32)};
      border: ${rem(1)} solid var(--color-white);
      border-radius: ${rem(32)};
    }

    .product-entry-testimonial__link-text {
      @media ${media.stMidUp} {
        font-size: ${rem(20)};
      }
    }
  }
`
